import { render } from "./PopUp.vue?vue&type=template&id=a0104ef2&scoped=true"
import script from "./PopUp.vue?vue&type=script&lang=js"
export * from "./PopUp.vue?vue&type=script&lang=js"

import "./PopUp.vue?vue&type=style&index=0&id=a0104ef2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0104ef2"]])

export default __exports__